import { action, makeObservable, observable, runInAction } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import { PartitionsClientApi } from '@servicetitan/marketing-services-api/identity';
import { NotificationsService } from '@servicetitan/notifications';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

@injectable()
export class PartitionsStore {
    @observable partition?: string;
    @observable partitions = [...this.standaloneRootStore.partitions];

    constructor(
        @inject(PartitionsClientApi) private partitionsClientApi: PartitionsClientApi,
        @inject(NotificationsService) private notifications: NotificationsService,
        @inject(StandaloneRootStore) private readonly standaloneRootStore: StandaloneRootStore,
    ) {
        makeObservable(this);

        this.partition = this.standaloneRootStore.tenant.currentPartitionId;
    }

    @action
    pickPartition = async (partition: string, onSuccess: (uri: string) => void) => {
        const oldPartition = this.partition;
        this.partition = partition;

        try {
            const mainPageUrl = `${window.location.protocol}//${window.location.host}`;
            const { data } = await this.partitionsClientApi.switchPartitions(
                partition,
                mainPageUrl,
            );

            if (data.redirectUri) {
                onSuccess(data.redirectUri);
            }

            if (data.error) {
                this.notifications.error({
                    title: 'Error',
                    message: data.errorDescription,
                });

                runInAction(() => {
                    this.partition = oldPartition;
                });
            }
        } catch (err: any) {
            this.notifications.error({
                title: err.name ?? 'Error',
                message: err.message ?? 'Unknown error',
            });
            runInAction(() => {
                this.partition = oldPartition;
            });
        }
    };

    get partitionName() {
        return this.partitions.find(p => p.internal_id === this.partition)?.display_name;
    }
}
